import {
  combineLatest,
  map,
  MonoTypeOperatorFunction,
  Observable,
  startWith,
} from 'rxjs';

/**
 * Combine stream with given events and transform it by provided function.
 *
 * @param changes Stream which provide new values to transform data by.
 * @param project Function that will transform data.
 */
export function transformerFactory<T, R>(
  changes: Observable<R>,
  project: (value: [T[], R], index: number) => T[]
): MonoTypeOperatorFunction<T[]> {
  return (source: Observable<T[]>) => {
    return source.pipe(
      s => combineLatest([s, changes.pipe(startWith(null))]),
      map(project)
    );
  };
}
